const COUNTRY_CONFIG = {
    US: {
        ppccHeroPage: true,
        charityDashboard: true,
        PPGF: true,
        skipAllowedBusinessType: true,
        verifyBank: true
    },
    GB: {
        collectCharityRegNo: true,
        charityDashboard: true,
        PPGF: true,
        allowedBusinessType: ['CORPORATION', 'PRIVATE_CORPORATION', 'NONPROFIT', 'GOVERNMENT'],
        ppccHeroPage: true,
        KYC: true
    },
    CA: {
        PPGF: true
    },
    AU: {
        PPGF: true,
    },
    IE: {
        charityDashboard: true,
        PPGF: true,
        allowedBusinessType: ['NONPROFIT'],
        KYC: true
    },
    AR: {
        techsoup: true,
        confirmationDays: 5,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 11,
            format: [new RegExp(/^(([0-9]{2}))[-]([0-9]{8})[-]([0-9]{1})$/)],
            example: ['12-34567890-0']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    CO: {
        techsoup: true,
        confirmationDays: 5,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 10,
            format: [new RegExp(/^(([0-9]{10}))$/), new RegExp(/^(([0-9]{9}))[-]([0-9]{1})$/), new RegExp(/^(([0-9]{3}))[.]([0-9]{3})[.]([0-9]{3})[-]([0-9]{1})$/)],
            example: ['1234567890', '123456789-0', '123.456.789-0']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    CL: {
        techsoup: true,
        confirmationDays: 5,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 9,
            format: [new RegExp(/^(([0-9]{2}))[.]([0-9]{3})[.]([0-9]{3})[-]([#]{1})$/), new RegExp(/^(([0-9]{2}))[.]([0-9]{3})[.]([0-9]{3})[-]([K]{1})$/), new RegExp(/^(([0-9]{2}))[.]([0-9]{3})[.]([0-9]{3})[-]([k]{1})$/)],
            example: ['12.345.678-#', '12.345.678-k', '12.345.678-K']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    PE: {
        techsoup: true,
        confirmationDays: 5,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 11,
            format: [new RegExp(/^(([0-9]{11}))$/)],
            example: ['12345678901']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    CR: {
        techsoup: true,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 10,
            format: [new RegExp(/^(([0-9]{1}))[-]([0-9]{3})[-]([0-9]{6})$/)],
            example: ['1-234-567890']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    DO: {
        techsoup: true,
        confirmationDays: 5,
        collectRegNo: true,
        regestrationNo: {
            type: 'BUSINESS_NUMBER',
            subType: 'BUSINESS_REGISTRATION_NUMBER',
            noOfDigits: 9,
            format: [new RegExp(/^(([0-9]{9}))$/), new RegExp(/^(([0-9]{1}))[-]([0-9]{2})[-]([0-9]{5})[-]([0-9]{1})$/), new RegExp(/^(([0-9]{1}))[-]([0-9]{2})[-]([0-9]{3})[-]([0-9]{3})$/)],
            example: ['123456789', '1-23-45678-9', '1-23-456-789']
        },
        noFeeDiscount: true,
        directModel: true,
    },
    DE: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    BE: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    PT: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    IT: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    FR: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    ES: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    SE: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    AT: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    PL: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    NL: {
        directModel: true,
        charityDashboard: true,
        KYC: true
    },
    LV: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    GR: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    LU: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    SK: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    HU: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    CZ: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    MT: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    SI: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    LT: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    CY: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    BG: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    NO: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    DK: {
        charityDashboard: true,
        directModel: true,
        KYC: true
    },
    BR: {
        directModel: true,
    },
    MX: {
        directModel: true,
    },
    PH: {
        charityDashboard: true,
        noFundraisingPlatform: true,
        CIP: true
    },
    SG: {
        charityDashboard: true,
        noFundraisingPlatform: true,
        CIP: true
    },
    NZ: {
        charityDashboard: true,
        noFundraisingPlatform: true,
        CIP: true,
    },
    IL: {
        directModel: true,
        charityDashboard: true,
        CIP: true,
        noFeeDiscount: true,
    },
    CH: {
        directModel: true,
        charityDashboard: true,
        CIP: true,
    },
}

export { COUNTRY_CONFIG }